import React, { memo, useEffect, useRef, useState } from 'react';
import ReactECharts from 'echarts-for-react';

import * as _ from 'lodash';
import { mapIndexList } from 'utils/config';
const appUrl = `${process.env.REACT_APP_ALGO_API_URL}`;

function usePrevious(value) {
  const ref = useRef();

  useEffect(() => {
    ref.current = value;
  }, [value]); // Only re-run if value changes

  return ref.current;
}

function ChartStockForeignBS(props) {
  const abortController = new AbortController();

  const DEFAULT_OPTION = {
    grid: { top: 8, right: 35, bottom: 20, left: 10 },
    xAxis: {
      type: 'category',
      boundaryGap:false,
      data: [],
      // splitNumber: 5,
      // minInterval: 3600 * 1000,
      axisLine: {
        show: false,
      },
      splitLine: {
        show: true,
        lineStyle: {
          type: 'dashed',
          color: '#4E4D62',
          dashOffset: 10,
          opacity: 0.3,
        },
      },
      axisTick: {
        show: false,
        alignWithLabel: false,
        length: 3,
      },
      axisLabel: {
        color: '#83817C',
        fontSize: 8,
        formatter: function (value, index) {
          const arr = value.split(':');
          return arr[0] + ':' + arr[1];
        },
        // width: 100,
        // overflow: 'truncate',
        interval: 60 * 100,
        borderColor: '#ECECEC',
        showMinLabel: true,
        showMaxLabel: true,
      },
    },
    yAxis: {
      type: 'value',
      show: true,
      position: 'right',
      alignTicks: true,
      splitNumber: 4,
      //   axisLine: {
      //     show: true,
      //     lineStyle: {
      //         type: 'dashed',
      //         color: '#4E4D62'
      //     }
      //   },
      splitLine: {
        // show: false,
        lineStyle: {
          type: 'dashed',
          color: '#4E4D62',
          dashOffset: 10,
          opacity: 0.3,
        },
      },
      axisLabel: {
        formatter: val => `${Math.abs(val) >= 1000000 ? val/ 1000000 : val/ 1000}${Math.abs(val) >= 1000000 ? 'M' : 'K'}`,
        color: '#83817C',
        fontSize: 8,
        showMinLabel: false,
        showMaxLabel: false,
      },
    },
    series: [
      {
        type: 'line',
        smooth: true,
        symbol: 'none',
        sampling: 'lttb',
        itemStyle: {
          color: '#03CAA6',
        },
        lineStyle: {
          width: 1,
        },
        areaStyle: {
          color: '#20CA78',
        },
        data: [],
      },
    ],
    tooltip: false,
  };

  const [option, setOption] = useState(DEFAULT_OPTION);

  const { symActive, algoSChart } = props;
  const preAlgoSChart = usePrevious(algoSChart);

  React.useEffect(() => {
    if(symActive) {
      // clear data
      const newOption = _.cloneDeep(option);
      console.log(newOption)
      let xAxis = [];
      let yAxis = [];

      newOption.yAxis.min = 0;
      newOption.yAxis.max = 1;
      newOption.series[0].data = yAxis;

      setOption(newOption);
      _handleLoadDataStock()
    }
}, [symActive])


React.useEffect(() => {
  if (
    algoSChart &&
    !_.isEqual(algoSChart, preAlgoSChart) &&
    algoSChart[0] === symActive
  ) {
    processRealtime({
      Time: algoSChart[1],
      PriceChange: algoSChart[3],
      MatchPrice: algoSChart[2],
      MatchVolume: algoSChart[4],
      OrderType: algoSChart[7],
      TotalBuyVolume: algoSChart[11],
      TotalSellVolume: algoSChart[12],
      BuyForeignValue: algoSChart[13],
    })
  }
}, [algoSChart])


function processRealtime(record) {
  const newOption = _.cloneDeep(option);
  console.log(newOption)
  let xAxis = newOption.xAxis.data;
  let yAxis = newOption.series[0].data;

  // time
  xAxis.push(record.Time)
  // data
  yAxis.push(record.BuyForeignValue)
  const _min = _.min(yAxis);
  const _max = _.max(yAxis);
  newOption.yAxis.min = _min;
  newOption.yAxis.max = _max;
  newOption.series[0].data = yAxis;

  setOption(newOption);
}


function _handleLoadDataStock() {
  if(!symActive) return;

  fetch(appUrl + 'pbapi/api/stockBoard/chart/stock/' + symActive, {
    signal: abortController.signal,
  })
    .then((response) => response.json())
    .then((res) => {
      if (res.status === 200) {
        _mapDataToState(res.data);
      }
    })
    .catch((error) => {
    });
}


  function _mapDataToState(dt) {
    const newOption = _.cloneDeep(option);

    // const _rand = Math.random() - 0.5;

    const yAxis = _.map(dt, o => o.BuyForeignQtty);
    const xAxis = _.map(dt, 'Time');

    const _min = _.min(yAxis);
    const _max = _.max(yAxis);

    // console.log(dt)

    newOption.xAxis.data = xAxis;
    newOption.yAxis.min = _min;
    newOption.yAxis.max = _max;
    newOption.series[0].data = yAxis;

    const _lastChange = dt[dt.length - 1].BuyForeignQtty;

    console.log(dt)

    if(_lastChange > 0){
      //up
      newOption.series[0].itemStyle.color = '#0FC786';
      newOption.series[0].areaStyle.color = '#0FC786';
    } else {
      // down
      newOption.series[0].itemStyle.color = '#F5465C';
      newOption.series[0].areaStyle.color = '#F5465C';
    }

    // console.log(xAxis);

    setOption(newOption);
  }
  
  return (
    <ReactECharts
      option={option}
      style={{
        height: '100%',
        width: `100%`,
      }}
    />
  );
}

export default memo(ChartStockForeignBS);
